import { render, staticRenderFns } from "./EmailNotifications.vue?vue&type=template&id=098d0dcf&"
import script from "./EmailNotifications.vue?vue&type=script&lang=js&"
export * from "./EmailNotifications.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer})
